import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { StateType } from 'src/redux/reducers';
import { Button, Text } from '@southfields-digital/mpxlive-components';
import classnames from 'classnames';

import ActionButtons from 'src/components/ActionButtons';
import DisplayHubStoryGraphic from '../DisplayHubStoryGraphic';
import { IDisplayHubStoryProps } from './types';

import styles from './DisplayHubStory.module.scss';

function DisplayHubStory(props: IDisplayHubStoryProps) {
  const { variant, id, name, playlistGraphicIds } = props;

  const { displayHubGraphics } = useSelector((state: StateType) => state.playlistGraphic);

  const graphics = useMemo(
    () => displayHubGraphics?.filter((graphic) => playlistGraphicIds.includes(graphic.id)),
    [displayHubGraphics]
  );

  const active = variant === 'static' ? false : props.active;
  const onClick = variant === 'static' ? () => {} : props.onClick;
  const onDuplicate = variant === 'static' ? () => {} : props.onDuplicate;
  const onDelete = variant === 'static' ? () => {} : props.onDelete;
  const onHandleMedia = variant === 'static' ? () => {} : props.onHandleMedia;

  const showActionButtons = variant === 'static' ? false : true;

  return (
    <div className={classnames(styles.DisplayHub, { [styles.Active]: active })} key={id}>
      <div className={styles.Content} onClick={onClick}>
        <div className={styles.StoryContent}>
          <Text as="p" lineClamp="clamp-1" className={styles.Label}>
            {name}
          </Text>
          <div className="flex flex-row gap-2">
            {graphics?.map((graphic, rowIndex) => (
              <DisplayHubStoryGraphic
                key={graphic.id}
                rowIndex={rowIndex}
                playlistGraphic={graphic}
                onHandleMedia={onHandleMedia}
              />
            ))}
          </div>
        </div>

        {showActionButtons && (
          <div className={styles.Options}>
            <ActionButtons isActive={active}>
              <Button iconProps={{ icon: 'copy' }} variant="secondary" onClick={onDuplicate} />
              <Button iconProps={{ icon: 'trash' }} variant="danger" onClick={onDelete} />
            </ActionButtons>
          </div>
        )}
      </div>
    </div>
  );
}

export default DisplayHubStory;
